export { ImageComponentContainer as default } from "./ImageComponentContainer";
